module.exports = __webpack_public_path__ + "static/media/va.7c8645ce.svg";